import React, { useEffect, useRef } from 'react'
import './Carousel.css'
import Card from './Card'

const Carousel = ({ cards, active, onChange, onActiveClick }) => {
    const carouselDivRef = useRef(null)

    const handleScroll = (event) => {
        const delta =
            Math.abs(event.deltaX) > Math.abs(event.deltaY)
                ? event.deltaX
                : event.deltaY
        if (delta > 0) {
            let id = Math.min(active + 1, cards.length - 1)
            onChange(id)
        } else if (delta < 0) {
            let id = Math.max(active - 1, 0)
            onChange(id)
        }
    }

    useEffect(() => {
        const carouselDiv = carouselDivRef.current
        if (!carouselDiv) return

        carouselDiv.addEventListener('wheel', handleScroll)

        return () => {
            carouselDiv.removeEventListener('wheel', handleScroll)
        }
    }, [active, cards, carouselDivRef.current])

    const getVisibleImages = () => {
        const leftImages = []
        const rightImages = []
        for (let i = 1; i <= 4; i++) {
            if (active - i >= 0) {
                leftImages.unshift({
                    card: cards[active - i],
                    cardIndex: active - i,
                })
            }
            if (active + i < cards.length) {
                rightImages.push({
                    card: cards[active + i],
                    cardIndex: active + i,
                })
            }
        }

        while (leftImages.length < 4) {
            leftImages.unshift({
                card: (
                    <Card
                        key={0 - leftImages.length}
                        url=""
                        name=""
                        height="215"
                        width="200"
                        curCard={``}
                        cardId={0 - leftImages.length}
                    />
                ),
                cardIndex: -1,
            })
        }
        return { leftImages, rightImages }
    }

    const { leftImages, rightImages } = getVisibleImages()

    return (
        <div ref={carouselDivRef} className="carousel">
            <div className="image-container">
                {leftImages.map(({ card, cardIndex }, index) => (
                    <div
                        key={index}
                        className="inactive-1px cardParent-1px"
                        onClick={() => cardIndex >= 0 && onChange(cardIndex)}
                    >
                        {card}
                    </div>
                ))}

                <div
                    id="active-1px"
                    onClick={() => onActiveClick(active)}
                    className="active-1px cardParent-1px"
                    cardId={active}
                >
                    {cards[active]}
                </div>
                {rightImages.map(({ card, cardIndex }, index) => (
                    <div
                        key={index}
                        className="inactive-1px cardParent-1px"
                        onClick={() => onChange(cardIndex)}
                    >
                        {card}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Carousel
